import * as React from 'react';
import classnames from 'classnames';
import Portal from '../portal/Portal';
import Draggable from 'react-draggable'; // The default

export interface IModalProps {
    isOpen?: boolean;
    onClose?: (event) => void;
    className?: string;
}

const DraggableModal: React.SFC<IModalProps> = (props) => {
    const { children, isOpen, onClose, className } = props;
    return (
        <Portal>
            <Draggable
                axis="both"
                bounds="body"
                onStart={(e) => {
                    // disable dragging on INPUT tag
                    if (e.target?.['tagName'] === 'INPUT') {
                        return false;
                    }
                }}
            >
                <div
                    className={classnames('modal-dialog draggable', {
                        [className]: !!className
                    })}
                    style={{
                        top: window.innerHeight / 2,
                        left: window.innerWidth / 2
                    }}
                    role="document"
                >
                    <div className="modal-content">{children}</div>
                </div>
            </Draggable>
        </Portal>
    );
};

export default DraggableModal;
